import './terms-view.module.scss';
import Page from '../../components/page/page';
import { Container, Typography } from '@mui/material';
import { GAID } from '../../libs/gtag';

/* eslint-disable-next-line */
export interface TermsViewProps {}

export function TermsView(props: TermsViewProps) {
  const sectionHeaderStyle = { mt: 3, mb: 1 };
  const listStyle = { marginTop: 0, marginBottom: 0 };

  const isGAEnabled = !!GAID;

  return (
    <>
      <Container maxWidth="md" sx={{ my: 4 }}>
        <Typography variant="h3" sx={{ mb: 4 }}>
          当サービスについて
        </Typography>
        {isGAEnabled && (
          <>
            <Typography variant="h4" sx={{ mb: 1 }}>
              利用状況の収集
            </Typography>
            <ul style={listStyle}>
              <li>
                本サービスは、本サービスの利用状況を収集・分析するために、Google社が提供する「Googleアナリティクス」を使用しています。
              </li>
              <li>
                「Googleアナリティクス」は、アクセス情報の収集のためにCookie等を利用しています。
              </li>
              <li>
                「Googleアナリティクス」で収集された情報は、Google社により同社のプライバシーポリシーに基づいて管理されます。
              </li>
              <li>
                「Googleアナリティクス」の利用規約及びGoogle社のプライバシーポリシーに関しては、それぞれ同社のサイトをご覧ください。
              </li>
              <li>
                「Googleアナリティクス」の利用規約(
                <a href="https://marketingplatform.google.com/about/analytics/terms/jp/">
                  https://marketingplatform.google.com/about/analytics/terms/jp/
                </a>
                )
              </li>
              <li>
                Google社のプライバシーポリシー(
                <a href="https://policies.google.com/privacy?hl=ja">
                  https://policies.google.com/privacy?hl=ja
                </a>
                )
              </li>
              <li>
                「Googleアナリティクス」は、Google社から提供されている「Googleアナリティクスオプトアウトアドオン」を利用することで無効にすることができます。
              </li>
              <li>
                Googleeアナリティクスオプトアウトアドオン(
                <a href="https://tools.google.com/dlpage/gaoptout">
                  https://tools.google.com/dlpage/gaoptout
                </a>
                )
              </li>
              <li>
                また、「ユーザーがGoogleパートナーのサービスやアプリを使用する際のGoogleによるデータ使用」に関して確認したい場合は、こちら（
                <a href="https://policies.google.com/technologies/partner-sites?hl=ja">
                  https://policies.google.com/technologies/partner-sites?hl=ja
                </a>
                ）をご参照ください。
              </li>
            </ul>
          </>
        )}

        <Typography variant="h4" sx={{ mt: 4, mb: 1 }}>
          トラッキングツール
        </Typography>
        <Typography sx={{ fontSize: 16 }}>
          本サービスでは、本サービスの利用状況の把握のために以下のトラッキングツールを利用しています。
        </Typography>
        <ul style={listStyle}>
          <li>
            Sentry
            <ul>
              <li>Terms of Service (https://sentry.io/terms/)</li>
              <li>Privacy Policy (https://sentry.io/privacy/)</li>
            </ul>
          </li>
        </ul>

        <Typography variant="h4" sx={{ mt: 4 }}>
          利用規約
        </Typography>
        <Typography variant="h5" sx={sectionHeaderStyle}>
          １. 重要事項
        </Typography>
        <ul style={listStyle}>
          <li>
            本サービスの使用に当たっては、アルゲンタム・コード株式会社（以下「当社」といいます）は、ユーザーに対し
            <ul>
              <li>
                本サービスの提供するデータ・情報等の一部、または全部を第三者に提供等すること
              </li>
              <li>
                本サービスの提供するデータ・情報等の一部、または全部を第三者と共有等すること
              </li>
              <li>本サービスの提供するデータ・情報等を加工等すること</li>
              <li>本サービスを自身の資産運用等の私的目的以外に使用すること</li>
              <li>本サービスを業務目的で使用すること</li>
            </ul>
            を禁止します。
          </li>
          <li>
            本サービスの使用にあたり、ユーザーは、関係法令諸規則、日本証券業協会および金融商品取引所の諸規則を遵守するものとします。ユーザーは、株式会社東京証券取引所（以下「東証」）の「相場情報使用に関するポリシー」（以下「東証ポリシー」）におけるエンドユーザに該当し、東証ポリシーにおけるエンドユーザとして東証ポリシーの規定に従い、特に東証から調査協力依頼があった際には必ずそれに応じ、協力するものとします。
          </li>
        </ul>

        <Typography variant="h5" sx={sectionHeaderStyle}>
          ２. 本サービスの変更または終了
        </Typography>
        <ul style={listStyle}>
          <li>
            当社は、本サービスの機能の追加や削除および、本サービスの一部または全部の一時停止や本サービスの終了を、予告なく行うことができます。
          </li>
          <li>
            当社は、規約に反したユーザーや、その他、当社が不適当と考えるユーザーについて、本サービスの提供を行わないことがあります。
          </li>
        </ul>

        <Typography variant="h5" sx={sectionHeaderStyle}>
          ３. 個人情報
        </Typography>
        <ul style={listStyle}>
          <li>
            当社は、個人情報等の保護に関する関係諸法令、主務大臣のガイドライン及び認定個人情報保護団体の指針を遵守します。
          </li>
          <li>
            当社は、本サービスを提供するにあたり、ユーザーからの同意のもと、電磁的方法により、ユーザーの氏名、住所、及びメールアドレス等の個人情報を取得することがあります。当社は、ユーザーから取得した個人情報を、ユーザーの管理、本サービスの円滑な提供及び関連するアフターサービスの提供、当社の提供するサービスの案内のために利用することがあります。
          </li>
          <li>
            当社は、ユーザーから取得した個人情報の漏えい等を防止するため、必要かつ適切な安全管理措置を実施するとともに、役職員の適切な監督を行います。また、当社は、ユーザーから取得した個人情報の適正な取扱いを図るため、個人情報保護に関する規程を適宜見直し、継続的な改善に努めます。
          </li>
          <li>
            当社に対する、個人情報に関するお問い合わせは、下記窓口に連絡するものとします。
            <br />
            ＜当社個人情報お問い合わせ窓口＞ E-mail：
            <a href="mailto:contact@argentumcode.co.jp">
              contact@argentumcode.co.jp
            </a>
          </li>
        </ul>

        <Typography variant="h5" sx={sectionHeaderStyle}>
          ４. 免責事項
        </Typography>
        <ul style={listStyle}>
          <li>
            本サービスは、提供するデータ・情報等を含めて、その正確性・完全性・可用性・リアルタイム性・継続的提供を保証するものではありません。また、特定目的適合性の保証を含むあらゆる明示的または暗示的な保証なく提供されるものです。ユーザーが本サービスを使用すること、もしくは使用できなかったことにより生じた損害について、当社およびその代理人または委託を受けた者、本サービスへの情報提供元である東証、およびそれらの役職員は、故意または故意に準ずる重大な過失により生じたものを除いて、その責を負わないものとします。特に、ユーザーは、東証の故意または故意に準ずる重大なる過失により損害が生じた場合を除いて、東証に対して一切補償または損害賠償等の請求を行わないものとします。
          </li>
        </ul>

        <Typography variant="h5" sx={sectionHeaderStyle}>
          ５. 本規定の変更
        </Typography>
        <ul style={listStyle}>
          <li>
            当社は、関係法令諸規則、日本証券業協会および金融商品取引所の諸規則の改正、社会情勢の変化その他の事情により、本規定を変更する必要が生じた場合には、本規定を変更することができます。
          </li>
          <li>
            当社は、本規定を変更する場合には、変更後の本規定の内容および変更の効力発生日を、効力発生日までに、本サービスのウェブサイト（
            https://timely-disclosure.brisk.jp/）に掲載することにより周知するものとします。
          </li>
        </ul>

        <Typography variant="h5" sx={sectionHeaderStyle}>
          ６. 準拠法
        </Typography>
        <ul style={listStyle}>
          <li>
            本規定に関する準拠法は、日本法とします。また、本サービスも日本法に則り、その範囲内において運用します。
          </li>
        </ul>

        <Typography sx={{ mt: 3 }}>効力発生日：2022年2月1日</Typography>
      </Container>
    </>
  );
}

export default TermsView;
